module.exports = __webpack_public_path__ + "static/media/PictoCarrocaria_2pt.8221ed32.svg";